import Vue from 'vue'
import axios from 'axios'
import _ from 'lodash'
import moment from 'moment'
import VueQRCodeComponent from 'vue-qrcode-component'
import applyConverters from 'axios-case-converter'
import ActionCableVue from 'actioncable-vue'

import App from './App.vue'
import router from './router/router.js'
import './registerServiceWorker'
import store from './stores/Store.js'
import i18n from './i18n'
import EaClick from './directives/ea-click.js'
import Version from '@/vcs/_shared/Version.vue'

// INFO: most important global functions and variables encapsulated in Globals.js
import './globals/Globals.js'
Vue.prototype.$clearRemoteClientLocalStorage()

window._ = _
window.moment = moment
moment.locale('pl')

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL
applyConverters(axios)
// INFO: We inject userToken when $isRemoteClient does requests.
// Exceptions: /map route
axios.interceptors.request.use(
  function (config) {
    let isExcludedRoute = config.url.includes('open_boxes')
    let isCpRoute = config.url.includes('collection_points')
    let isRemoteClient = Vue.prototype.$isRemoteClient
    let token = window.localStorage.getItem('user_token')

    if (isRemoteClient && !isExcludedRoute && isCpRoute && token && token.length) {
      config.headers.common['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  (response) => {
    return response
  },
  function (error) {
    if (Vue.prototype.$isRemoteClient && ((error || {}).response || {}).status == '401') {
      signOut()
    }
    return Promise.reject(error)
  }
)

let signOut = () => {
  Vue.prototype.$blockUI()
  let userToken = window.localStorage.getItem('user_token')
  let fingerprint = window.localStorage.getItem('fingerprint')
  axios({
    method: 'delete',
    url: '/auth/remote_sign_out',
    headers: {
      common: {
        Authorization: `Bearer ${userToken}`
      }
    },
    data: {
      fingerprint: fingerprint,
      token: userToken
    }
  })
    .then((response) => {
      if (response.status == 204) {
        store.commit('setUserToken', '')
        store.commit('removeCp')
        router.push('/qr')
      }
    })
    .catch((error) => {
      Vue.prototype.$errorHumanized(null, 'not authorized')
    })
    .finally(() => {
      Vue.prototype.$unblockUI()
    })
}

let slug = () => {
  let host = window.location.host
  let hostMatch = host.match(/^(.*?)\./)

  if (hostMatch && hostMatch[1] != 'collection-point') {
    return hostMatch[1]
  } else {
    return ''
  }
}

let slugAndPrefix = () => {
  return `${slug()}.collection-point.`
}

let connectionUrl = () => {
  if (Vue.prototype.$production) {
    if (slug()) {
      return `wss://${slugAndPrefix()}collectomate.io/api/cable`
    } else {
      return `wss://app.collectomate.io/api/cable`
    }
  } else if (Vue.prototype.$preprod) {
    return `wss://${
      slug() ? slugAndPrefix() : ''
    }collectomate-preprod.enginearch.com/api/cable`
  } else if (Vue.prototype.$dev) {
    return 'ws://localhost:3000/api/cable'
  }
}

// plugins
Vue.use(ActionCableVue, {
  debug: true,
  debugLevel: 'error',
  connectionUrl: connectionUrl(),
  connectImmediately: true
})

// components
Vue.component('qr-code', VueQRCodeComponent)
Vue.component('version', Version)

// directives
Vue.directive('ea-click', EaClick)

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
